import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "../utils/fontface.css";

import Header from "../components/molecules/Header";
import Footer from "../components/molecules/Footer";

import GlobalStyles from "../components/atoms/GlobalStyles";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../utils/styling";
import { useWindowSize } from "react-use";
import OpeningScreen from "../components/organisms/OpeningScreen";

const Bg = styled.div`
  background-color: #000;
  z-index: 10;
  position: relative;
`;

function Index({ children, location }) {
  const size = useWindowSize();

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--windowHeight",
      `${size.height}px`
    );
  }, [size]);

  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        {location.pathname === "/" && <OpeningScreen />}
        <Bg>
          <Header />
          <main>{children}</main>
          <Footer />
        </Bg>
      </>
    </ThemeProvider>
  );
}

Index.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Index;

